import { render, staticRenderFns } from "./ajlb.vue?vue&type=template&id=382110b4&scoped=true&"
import script from "./ajlb.vue?vue&type=script&lang=js&"
export * from "./ajlb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382110b4",
  null
  
)

export default component.exports